import React, { useState } from 'react';
import { useRouter } from 'next/router';
import {
  useGetNewsCategoriesBySlugQuery,
  useNewsHomepageQuery,
} from '@/generated/graphql';
import { getCurrentDateRoundedHour } from '@/utils';
import { NewsCategoryVerticalSection } from './NewsCategoryVerticalSection.1';
import { NewsCardHorizontal } from './NewsCardHorizontal';
import { UrlLink } from '@/configs/urlLink';
import { ContactFormCate } from './ContactFormCate';

export const ITEMS_PER_PAGE = 7;

export function NewsCategoryBottomSection() {
  const router = useRouter();
  const [offset, setOffset] = useState(0);
  const { data: DataDetailCategory } = useGetNewsCategoriesBySlugQuery({
    variables: {
      where: {
        slug: {
          _like: router?.query?.slug?.toString() || '',
        },
      },
    },
  });

  // const { data: TopNews } = useNewsHomepageQuery({
  //   variables: {
  //     limit: 5,
  //     orderBy: { create_at: Order_By.DescNullsLast },
  //     where: {
  //       news_category: {
  //         id: { _eq: DataDetailCategory?.news_category?.[0]?.id },
  //       },
  //       _or: [
  //         {
  //           isHot: { _eq: true },
  //         },
  //         {
  //           date: {
  //             _lte: getCurrentDateRoundedHour(),
  //           },
  //         },
  //       ],
  //       is_public: {
  //         _eq: true,
  //       },
  //     },
  //   },
  // });

  const { data, fetchMore } = useNewsHomepageQuery({
    variables: {
      limit: ITEMS_PER_PAGE,
      where: {
        news_category: {
          id: { _eq: DataDetailCategory?.news_category?.[0]?.id },
        },
        // id: { _nin: TopNews?.news?.map(item => item.id) },
        date: {
          _lte: getCurrentDateRoundedHour(),
        },
        is_public: {
          _eq: true,
        },
      },
    },
  });

  const handleLoadMore = () => {
    fetchMore({
      variables: { offset: offset + ITEMS_PER_PAGE },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return Object.assign({}, prev, {
          news: [...prev.news, ...fetchMoreResult.news],
        });
      },
    });
    setOffset(offset + ITEMS_PER_PAGE);
  };

  return (
    <div className="flex flex-col justify-between px-4 lg:container lg:flex-row lg:px-0">
      <div className="flex flex-col gap-4 lg:w-[800px]">
        {data?.news.map((item, index) => (
          <NewsCardHorizontal
            key={index}
            title={item?.title}
            src={item?.thumbnail}
            // tag={item?.news_category?.name}
            link={`${UrlLink.news.news}/${item?.slug}-${item?.id}`}
            sub_link={`${UrlLink.news.news}/${item?.news_category?.slug}`}
            content={item?.meta_description}
          />
        ))}
        {Number(data?.news.length) <
          Number(data?.news_aggregate?.aggregate?.count) && (
          <p
            className="text-neutral-grayDark hover:text-primary-eastern text-PC-Display-H5 mb-4 cursor-pointer self-center font-sans lg:mb-8"
            onClick={handleLoadMore}
          >
            Xem thêm
          </p>
        )}
      </div>
      <div className="flex flex-col gap-6 lg:w-[300px]">
        <ContactFormCate title="Bạn có muốn nhận những thông tin tương tự không?" />
        <NewsCategoryVerticalSection />
      </div>
    </div>
  );
}
